module.exports = __webpack_public_path__ + "img/scaled access_organigrams SCALE-11.svg";